(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }
        hide() {
          super.hide();
          window.pauseAllMedia();
        }
        show(opener) {
          super.show(opener);
          this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
        }

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
				}, 300))
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, 300)
				);
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        const lazyImages = this.querySelectorAll('.lazy-image');
        if (lazyImages.length > 0) {
          lazyImages.forEach((img) => {
            this.loadImage(img);
            img.classList.remove('lazy-image');
          });
        }
      }

      loadImage = (img) => {
        img.src = img.dataset.src;
        img.srcset = img.dataset.srcset;
        img.sizes = img.dataset.sizes;
        img.classList.remove('lazy-image');
      };

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }

    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();
})();
